import { appAttachmentIcon } from './attachment';
import { appWorldIcon } from './world';
export const sharedIcons = [appAttachmentIcon, appWorldIcon];
